module.exports = __webpack_public_path__ + "img/组 32@2x.72ffc8ba.png";